<template>
    <div class="space-y-6 text-center">
      <h2 class="text-2xl md:text-3xl font-bold">
        {{ $t("totalForm.step0.title") }}
      </h2>
      <p class="text-gray-600 max-w-md mx-auto">
        {{ $t("totalForm.step0.desc") }}
      </p>
      <button @click="$emit('next')" class="btn btn-primary w-full max-w-xs mx-auto">
        {{ $t("totalForm.step0.cta") }}
      </button>
      <p class="text-sm text-gray-400">{{ $t("totalForm.step0.note") }}</p>
    </div>
  </template>
  